import { parseMerchantConfig, prepareCreateIntent } from './merchant-config';
import StaticIdSingletonClass from './static-id';
/**
 * Method to extract review comments if the message length is greater than 100
 *
 * @param  {review} review - Review object from the merchant vinit param
 * @return {object} object - review data
 */
const getReviewParams = review => {
  const reviewObject = {};
  if (review) {
    if (review.message) {
      reviewObject.reviewMessage =
        review.message.length <= 100
          ? review.message
          : 'This will complete your purchase to this merchant.';
    }
    if (review.buttonAction) {
      reviewObject.buttonAction = review.buttonAction;
    }
  }
  return reviewObject;
};

/**
 * Method to remove null, undefined & empty from the object
 *
 * @param  {obj} obj - Parsed Intent data
 * @return {object} Object - return clean object
 */
const cleanObject = obj => {
  Object.keys(obj).forEach(key => {
    const val = obj[key];
    if (val && typeof val === 'object') {
      cleanObject(obj[key]);
    } else if (val === '' || val === null || val === undefined) {
      delete obj[key];
    }
  });
  return obj;
};

/**
 * Method to prepare payload for the create intent call.
 *
 * @param  {config} config - Merchant data.
 * @return {object} object - Visa intent data.
 */
export default config => {
  let collectBillingAddress;
  if (!StaticIdSingletonClass.visaSrci) {
    collectBillingAddress = config?.vInitRequest?.payment?.collectBillingAddress ?? null;
  }
  const vInitRequest = config?.vInitRequest;
  const parsedMerchantConfig = parseMerchantConfig(vInitRequest);
  const intentData = prepareCreateIntent(parsedMerchantConfig);

  delete intentData.currencyFormat;
  delete intentData.apikey;
  delete intentData.customData;
  delete intentData.referenceCallID;

  const updatedIntentData = Object.assign({}, intentData, getReviewParams(vInitRequest.review));

  const cleanIntentData = cleanObject(updatedIntentData);
  cleanIntentData.srciProfile = !StaticIdSingletonClass.visaSrci;

  // if external srci and we have collectBillingAddress
  /* eslint-disable */
  if (!StaticIdSingletonClass.visaSrci && collectBillingAddress) {
    if (!cleanIntentData.merchantConfig) {
      cleanIntentData.merchantConfig = {};
      cleanIntentData.merchantConfig.billingConstraints = {};
      cleanIntentData.merchantConfig.billingConstraints.collectBillingAddress = collectBillingAddress;
    } else if (!cleanIntentData.merchantConfig.billingConstraints) {
      cleanIntentData.merchantConfig.billingConstraints = {};
      cleanIntentData.merchantConfig.billingConstraints.collectBillingAddress = collectBillingAddress;
    } else {
      cleanIntentData.merchantConfig.billingConstraints.collectBillingAddress = collectBillingAddress;
    }
  }

  return cleanIntentData;
};
